import { useAppointment } from '../../context/appointmentContext';
import { useTestContext } from '../../context/testContext';
import { client } from '../api-client';

const useStrokeResultsSubmission = () => {
  const { appointment } = useAppointment();
  const { testData } = useTestContext();

  const resultData = {
    visualFieldForthValley: {
      results: {
        forthValleyVisualFieldDots: testData?.forthValleyVisualFieldDots,
        ...testData?.visualFieldForthValley?.results,
      },
    },
  };

  const submitResults = async () => {
    const getMotilityImages = async () => {
      const motilityImageData = JSON.parse(localStorage.getItem('cornerFixationImages'));

      const motilityImagesArray = await Promise.all(
        motilityImageData.map(async (img, index) => {
          const imgDataToBlob = await fetch(img).then((data) => data.blob());
          const file = new File([imgDataToBlob], `eyeMotility${index}.jpg`, { type: 'image/jpeg' });
          return file;
        }),
      );
      return motilityImagesArray;
    };

    const getMotilityVideo = async () => {
      const motilityVideoData = JSON.parse(localStorage.getItem('videoRecordingData'));
      const videoDataToBlob = await fetch(motilityVideoData).then((response) => response.blob());
      const file = new File([videoDataToBlob], `eyeMotilityVideo-${appointment?.currentAppointment?.id}.mp4`, { type: 'video/mp4' });
      return file;
    };

    const motilityImages = await getMotilityImages();
    const motilityVideo = await getMotilityVideo();

    const formData = new FormData();
    motilityImages.forEach((img, index) => formData.append(`motilityImage${index}`, img));
    formData.append('motilityVideo', motilityVideo);
    formData.append('appointment_eye_test', testData.eyeTestId);
    formData.append('appointment', appointment.currentAppointment.id);
    formData.append('result_data', JSON.stringify(resultData));

    return client('api/appointment-test-result/', { body: formData }).then(
      () => {
        return true;
      },
      (err) => console.error(err),
    );
  };

  return submitResults;
};

export default useStrokeResultsSubmission;
